import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { PlacementsRoutingModule } from './placements-routing.module';
import { PlacementsListComponent } from './placements-list/placements-list.component';
import { PlacementsCreateComponent } from './placements-create/placements-create.component';

@NgModule({
  declarations: [PlacementsListComponent, PlacementsCreateComponent],
  imports: [
    CommonModule,
    PlacementsRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class PlacementsModule { }
